import { Box, Button } from "@mui/material";
import { t } from "i18next";
import React from "react";

const ButtonToolbar = ({ onCancel, onSubmit, isFormValid, isFormDirty, onSaveLabel, isWithAppForm = true }) => {
  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
      <Button
        type="button"
        variant="outlined"
        color="secondary"
        onClick={handleCancel}
        sx={{
          width: {
            xl: "200px",
            lg: "200px",
          },
          borderRadius: "5px",
          borderColor: "#A62B23",
          color: "#A62B23",
          fontWeight: "bold",
          backgroundColor: "white",
          flex: "none",
          textTransform: "none",
        }}
      >
        {t("generic.cancel")}
      </Button>
      {isWithAppForm ? (
        <Button
          type="submit"
          variant="contained"
          disabled={!(isFormValid && isFormDirty)}
          sx={{
            width: {
              xl: "200px",
              lg: "200px",
            },
            borderRadius: "5px",
            color: "#FFFFFF",
            borderColor: "#A62B23",
            backgroundColor: "#A62B23",
            flex: "none",
            "&.Mui-disabled": {
              backgroundColor: "#C57570",
              color: "#FFFFFF",
            },
            textTransform: "none",
          }}
        >
          {onSaveLabel ? onSaveLabel : "Submit for Approval"}
        </Button>
      ) : (
        <Button
          type="button"
          variant="contained"
          onClick={handleSubmit}
          disabled={!isFormValid}
          sx={{
            width: {
              xl: "200px",
              lg: "200px",
            },
            borderRadius: "5px",
            color: "#FFFFFF",
            borderColor: "#A62B23",
            backgroundColor: "#A62B23",
            flex: "none",
            "&.Mui-disabled": {
              backgroundColor: "#C57570",
              color: "#FFFFFF",
            },
            textTransform: "none",
          }}
        >
          {onSaveLabel ? onSaveLabel : "Submit for Approval"}
        </Button>
      )}
    </Box>
  );
};

export default ButtonToolbar;
